import { Box, Stack, Typography } from '@mui/material';
import { Flip, Fade } from 'react-awesome-reveal';
import sectionConstants from '../../constants/SectionConstants';
import '../styles/Section7.scss';

const Section7 = () => {
  return (
    <Box className='section7-image'>
      <Fade>
        <Stack
          className='footer-heading'
          alignItems='center'
          direction='row'
          justifyContent='center'
        >
          {sectionConstants.WhatWeDo}
        </Stack>
      </Fade>
      <Flip direction='horizontal'>
        <Stack
          direction='row'
          p={5}
          spacing={4}
          className='section7-content'
          alignItems='start'
        >
          <Typography className='section7-heading'>
            {sectionConstants.WhatWeDoMsg}
          </Typography>
          <Typography className='section7-para'>
            <Box
              sx={{
                listStyleType: 'disc',
                color: '#e5e8f8',
                ml: 3,
                '& > div': {
                  display: 'list-item',
                  mb: 1
                }
              }}
            >
              <Box>{sectionConstants.FleetManagers}</Box>
              <Box>{sectionConstants.BusinessOwners}</Box>
              <Box>{sectionConstants.LogisticsCompanies}</Box>
              <Box>{sectionConstants.TransportationServices}</Box>
              <Box>{sectionConstants.ConstructionCompanies}</Box>
              <Box>{sectionConstants.EmergencyServices}</Box>
              <Box>{sectionConstants.CourierAndPackageDeliveryServices}</Box>
            </Box>
          </Typography>
        </Stack>
      </Flip>
    </Box>
  );
};

export default Section7;
